import React, { useState, useEffect } from 'react';

const EditTrainerModal = ({ isOpen, onClose, trainerData, onSave, sitesData }) => {
  const [selectedSiteIDs, setSelectedSiteIDs] = useState([]);
  const [showSites, setShowSites] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (trainerData && sitesData.length > 0) {
      const assignedSiteIDs = trainerData.permissions.map(perm => perm.SiteID);
      setSelectedSiteIDs(assignedSiteIDs);
    }
  }, [trainerData, sitesData]);

  const handleCheckboxChange = (siteID) => {
    setSelectedSiteIDs(prev => prev.includes(siteID) ? prev.filter(id => id !== siteID) : [...prev, siteID]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSave({
      TrainerID: trainerData.TrainerID,
      selectedSiteIDs,
      PermissionLevel: trainerData.permissions[0].PermissionLevel,
    });
    onClose();
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredSites = sitesData.filter(site =>
    site.SiteID.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (site.SiteName && site.SiteName.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (!isOpen) return null;

  return (
    <div className="my-custom-modal">
      <div className="my-custom-modal-content">
        <span className="close-button" onClick={onClose}>&times;</span>
        <form onSubmit={handleSubmit}>
          <h4>Editing Trainer: <span className="ml-3 text-danger">{trainerData.TrainerID}</span></h4>
          <button type="button" onClick={() => setShowSites(!showSites)} className="btn btn-secondary mt-2 mr-2">
            {showSites ? 'Hide Sites' : 'Show Sites'}
          </button>
          {showSites && (
            <>
              <input
                type="text"
                placeholder="Search Sites"
                value={searchTerm}
                onChange={handleSearchChange}
                className="form-control my-2"
              />
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {filteredSites.map(site => {
                  const isChecked = selectedSiteIDs.includes(site.SiteID);
                  return (
                    <div key={site.SiteID} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`site-${site.SiteID}`}
                        value={site.SiteID}
                        checked={isChecked}
                        onChange={() => handleCheckboxChange(site.SiteID)}
                      />
                      <label className="form-check-label" htmlFor={`site-${site.SiteID}`}>
                        {site.SiteName ? `${site.SiteName} (${site.SiteID})` : site.SiteID}
                      </label>
                    </div>
                  );
                })}
              </div>
            </>
          )}
          <button type="submit" className="btn btn-primary mt-2">Save Changes</button>
        </form>
      </div>
    </div>
  );
};

export default EditTrainerModal;

